import { render } from "./PokerRoom.vue?vue&type=template&id=205cd230"
import script from "./PokerRoom.vue?vue&type=script&lang=js"
export * from "./PokerRoom.vue?vue&type=script&lang=js"

import "./PokerRoom.vue?vue&type=style&index=0&id=205cd230&lang=css"
script.render = render

export default script